var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2336_5497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.18359 11.9596V4.04041C2.18359 3.72929 2.29753 3.46296 2.52541 3.24142C2.75329 3.01987 3.02723 2.90909 3.34723 2.90909H6.83814C7.15814 2.90909 7.43208 3.01987 7.65996 3.24142C7.88784 3.46296 8.00178 3.72929 8.00178 4.04041V5.17172H12.6563C12.9763 5.17172 13.2503 5.28249 13.4781 5.50404C13.706 5.72559 13.82 5.99192 13.82 6.30303V11.9596C13.82 12.2707 13.706 12.537 13.4781 12.7586C13.2503 12.9801 12.9763 13.0909 12.6563 13.0909H3.34723C3.02723 13.0909 2.75329 12.9801 2.52541 12.7586C2.29753 12.537 2.18359 12.2707 2.18359 11.9596ZM3.34723 11.9596H4.51087V10.8283H3.34723V11.9596ZM3.34723 9.69697H4.51087V8.56566H3.34723V9.69697ZM3.34723 7.43434H4.51087V6.30303H3.34723V7.43434ZM3.34723 5.17172H4.51087V4.04041H3.34723V5.17172ZM5.6745 11.9596H6.83814V10.8283H5.6745V11.9596ZM5.6745 9.69697H6.83814V8.56566H5.6745V9.69697ZM5.6745 7.43434H6.83814V6.30303H5.6745V7.43434ZM5.6745 5.17172H6.83814V4.04041H5.6745V5.17172ZM8.00178 11.9596H12.6563V6.30303H8.00178V7.43434H9.16541V8.56566H8.00178V9.69697H9.16541V10.8283H8.00178V11.9596ZM10.329 8.56566V7.43434H11.4927V8.56566H10.329ZM10.329 10.8283V9.69697H11.4927V10.8283H10.329Z",
    fill: "#B28301"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2336_5497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.c55e35fd746e24bc91ef3f36c9a6315d.svg";
export { ForwardRef as ReactComponent };